import { CompanySelectorProps, companyType } from "@ots-frontend/ots-data";
import { CompanySelect, CompanySelectProps } from "./CompanySelect";

type Props = Omit<CompanySelectProps, "selector"> & {
  selector?: Omit<CompanySelectorProps, "companyType">
};

export const OperatorCompanySelect = (props: Props) => {
  const { selector, ...rest } = props;

  return (
    <CompanySelect
      {...rest}
      selector={{
        ...selector,
        companyType: companyType.operator
      }} />
  );
};
